import Vue from "vue";
import Router from "vue-router";
import { getToken, removeToken } from "@/util/cookie.js";
import cashRouters from "./modules/cash";
import componentsRouters from "./modules/components";
import FromRouters from "./modules/from";
Vue.use(Router);
// 存放动态路由
const asyncRouterList = [...cashRouters, ...componentsRouters, ...FromRouters];
export const componentsList = [...componentsRouters];
export const defaultRouterList = [
  {
    path: "/",
    // name: "Index",
    // component: Home,
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
    },
    // redirect: "/cash/logins",
    redirect: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../view/Login/index.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  {
    path: "/settle",
    name: "Settle",
    component: () => import("../view/Login/settle.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  {
    path: "/download",
    name: "download",
    component: () => import("../view/Login/download.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  {
    path: "/scene",
    name: "scene",
    component: () => import("../view/Login/scene.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("../view/Login/notice.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  {
    path: "/noticedetail",
    name: "noticedetail",
    component: () => import("../view/Login/nodicedetail.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
  ...asyncRouterList,
  // 404 页面
  {
    path: "/404",
    name: "NotFound",
    component: () => import("../view/Nofound/index.vue"),
    hidden: true,
    meta: { title: "404", requireAuth: false },
  },
  // 当什么都没有匹配到的时候，重定向页面到 404 页面
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
    name: "notMatch",
    hidden: true,
    meta: {
      // 判断此页是否需要登录
      requireAuth: false,
    },
  },
];
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: defaultRouterList,
});
// 重写router.push方法，防止重复点击报错
const originPush = Router.prototype.push; // 把官方的push方法暂存到originPush这个变量里面
Router.prototype.push = function push(location) {
  // 参数是调用push方法传进来的参数
  return originPush.call(this, location).catch(() => {});
};
// console.log(getToken());
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requireAuth)) {
    // 判断该路由是否需要登录权限
    if (getToken()) {
      // 判断当前的token是否存在 ； 登录存入的token
      if (to.path === "/login") {
        removeToken();
        window.location.reload();
      } else {
        next();
      }
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  if (to.path != from.path) {
    window.scrollTo(0, 0);
  }
});
export function resetRouter() {
  // console.log('执行了');
  const newRouter = new Router();
  router.matcher = newRouter.matcher; // reset router
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js